"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress/CircularProgress.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loader = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'small' : _props$size,
      disableShrink = props.disableShrink;
  return /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    ref: ref,
    size: size === 'large' ? 56 : 32,
    thickness: size === 'large' ? 4 : 2,
    disableShrink: disableShrink,
    "data-testid": props['data-testid']
  });
});

var _default = Loader;
exports.default = _default;